import { useSelectedApplication, useSelectedExpressEnrollTemplateName } from "../hooks";
import eaglePemfexyConfiguration from "./Eagle/configurations";
import pfizerCopayIvConfigurations from "./Pfizer/copay/iv/configurations";
import { useGenentechFreeDrugConfiguration } from "./Genentech/freeDrug/useGenentechFreeDrugConfiguration";
import pfizerFreeDrugConfigurations from "./Pfizer/configurations";
import { useGenentechCopayConfiguration } from "./Genentech/copay/useGenentechCopayConfiguration";
import pfizerCopayOralConfigurations from "./Pfizer/copay/oral/configurations";
import { useNovartisCopayConfiguration } from "./Novartis/copay/useNovartisCopayConfiguration";
import { usePfizerCopayOralIQVIAConfiguration } from "./Pfizer/copay/oral/iqvia/usePfizerCopayOralConfiguration";
import { useBmsCopayConfiguration } from "./Bms/copay/useBmsCopayConfiguration";
import { useBmsCopayLsConfiguration } from "./Bms/copayLs/useBmsCopayLsConfiguration";
import { useRegeneronCopayConfiguration } from "./Regeneron/copay/useRegeneronCopayConfiguration";
import { useRegeneronPapConfiguration } from "./Regeneron/pap/useRegeneronPapConfiguration";
import { usePfizerFreeDrugSonnexusConfiguration } from "./PfizerSonnexus/freeDrug/usePfizerFreeDrugSonnexusConfiguration";
import { useLillyCopayConfiguration } from "./Lilly/copay/useLillyCopayConfiguration";
import { useLillyCopaySignatureConfiguration } from "./Lilly/copay/signature/useLillyCopaySignatureConfiguration";
import { useTevaCopayConfiguration } from "./Teva/copay/useTevaCopayConfiguration";
import { useGskCopayConfiguration } from "./Gsk/copay/useGskCopayConfiguration";
import { TEMPLATE_NAMES } from "./templateNames";

export const ExpressEnrollMapper = Object.freeze({
  [TEMPLATE_NAMES.PFIZER_FREE_DRUG]: pfizerFreeDrugConfigurations,
  [TEMPLATE_NAMES.GENENTECH_COPAY]: () => useGenentechCopayConfiguration(),
  [TEMPLATE_NAMES.PFIZER_COPAY_ORAL]: pfizerCopayOralConfigurations,
  [TEMPLATE_NAMES.PFIZER_COPAY_IV]: pfizerCopayIvConfigurations,
  [TEMPLATE_NAMES.EAGLE_PEMFEXY]: eaglePemfexyConfiguration,
  [TEMPLATE_NAMES.GENENTECH_FREE_DRUG]: () => useGenentechFreeDrugConfiguration(),
  [TEMPLATE_NAMES.NOVARTIS_COPAY]: () => useNovartisCopayConfiguration(),
  [TEMPLATE_NAMES.PFIZER_COPAY_ORAL_IQVIA]: () => usePfizerCopayOralIQVIAConfiguration(),
  [TEMPLATE_NAMES.BMS_COPAY]: () => useBmsCopayConfiguration(),
  [TEMPLATE_NAMES.BMS_COPAY_LS]: () => useBmsCopayLsConfiguration(),
  [TEMPLATE_NAMES.REGENERON_COPAY]: () => useRegeneronCopayConfiguration(),
  [TEMPLATE_NAMES.REGENERON_PAP]: () => useRegeneronPapConfiguration(),
  [TEMPLATE_NAMES.PFIZER_FREE_DRUG_SONNEXUS]: () => usePfizerFreeDrugSonnexusConfiguration(),
  [TEMPLATE_NAMES.LILLY_COPAY]: () => useLillyCopayConfiguration(),
  [TEMPLATE_NAMES.LILLY_COPAY_SIGNATURE]: () => useLillyCopaySignatureConfiguration(),
  [TEMPLATE_NAMES.TEVA_COPAY]: () => useTevaCopayConfiguration(),
  [TEMPLATE_NAMES.GSK_COPAY]: () => useGskCopayConfiguration()
});

export const getExpressEnrollmentMapping = () => {
  const expressEnrollTemplateName = useSelectedExpressEnrollTemplateName();
  const application = useSelectedApplication();

  const expressEnrollMapping = application?.hasExpressEnroll ? ExpressEnrollMapper[expressEnrollTemplateName] : null;

  const configuration = expressEnrollMapping instanceof Function ? expressEnrollMapping() : expressEnrollMapping;
  return configuration || {};
};
